/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */

import { NgModule } from '@angular/core';

import { NbSharedModule } from '../shared/shared.module';

// import { NbCardService } from './card.service';

import {
  NbCardComponent,
  NbCardBodyComponent,
  NbCardFooterComponent,
  NbCardHeaderComponent,
  NbCardToolsComponent,
} from './card.component';

const NB_CARD_COMPONENTS = [
  NbCardComponent,
  NbCardBodyComponent,
  NbCardFooterComponent,
  NbCardHeaderComponent,
  NbCardToolsComponent,
];

@NgModule({
  imports: [
    NbSharedModule,
  ],
  declarations: [
    ...NB_CARD_COMPONENTS,
  ],
  exports: [
    ...NB_CARD_COMPONENTS,
  ],
  // providers: [NbCardService],
})
export class NbCardModule { }



// WEBPACK FOOTER //
// ./src/framework/theme/components/card/card.module.ts